import React from 'react';

import type { TagEntity } from '@schibsted/frapi-schema';
import type { TagType } from '../../../../types/frapi-types.js';

import Tag from './Tag.js';
import { filterTagsOnType } from '../helpers.js';

type TagProps = {
  tags: TagEntity[];
  type: TagType | TagType[];
  noBorder?: boolean;
  regular?: boolean;
  limit?: number;
};

const Tags: React.FC<TagProps> = ({ tags, type, noBorder, limit, regular }) => (
  <div className="tag-wrapper">
    {filterTagsOnType(tags, type, limit).map((tag, index) => (
      <Tag key={index} tag={tag} noBorder={noBorder} regular={regular} />
    ))}
  </div>
);

export default Tags;
